<template>
    <div>
        <!-- PROMO SAN VALENTINO -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-glass-cheers</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.san_valentino_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.san_valentino_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2 class="pa-5">
                    <img :src="getImageUrl('img/promo/sanvalentino.jpeg')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- PROMO BLACK FRIDAY -->
        <!-- <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-euro-sign</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.black_friday_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.black_friday_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2 class="pa-5">
                    <img :src="getImageUrl('img/promo/promo_49.png')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section> -->

        <!-- PROMO CENONE CAPODANNO -->
        <!-- <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-glass-cheers</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.cenone_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.cenone_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2 class="pa-5">
                    <img :src="getImageUrl('img/promo/cenone_capodanno.png')" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section> -->

        <!-- SAINT AGATA PROMO -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6>
                    <img :src="getImageUrl('img/promo/s_agata.jpg')" alt="promo sant'agata oblobb" class="my-fit" style="min-height: 478px !important; ">
                </v-flex>
                <v-flex sm12 md6 lg6>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-euro-sign</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.agata_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.agata_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>

        <!-- RENT BIKE -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md1 order-lg1>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-moon</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.six_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.six_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md2 order-lg2>
                    <img src="http://www.casatalia.it/img/grid/servizi/004.jpg" alt="" class="my-fit">
                </v-flex>
            </v-layout>
        </section>

        <!-- LUNCH BOX -->
        <section>
            <v-layout row wrap>
                <v-flex sm12 md6 lg6 order-xs1 order-sm1 order-md1 order-lg1>
                    <img src="http://www.casatalia.it/img/grid/servizi/005.jpg" alt="" class="my-fit">
                </v-flex>
                <v-flex sm12 md6 lg6 order-xs2 order-sm2 order-md2 order-lg2>
                    <v-card class="elevation-0 transparent mt-5">
                        <v-card-title primary-title class="layout justify-center">
                            <v-icon size="70" class="success--text text--lighten-2">fas fa-percent</v-icon>
                        </v-card-title>
                        <v-card-title primary-title class="layout justify-center">
                            <div class="my-headline text-xs-center">{{$t("promo.custom10_title")}}</div>
                        </v-card-title>
                        <v-card-text class="layout justify-center">
                            <p class="sub-intro px-3">
                                {{$t("promo.custom10_details")}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </section>
    </div>
</template>

<script>
export default {
    methods: {
      getImageUrl: function(image){
        return require(`../assets/${image}`);
      }
    }
}
</script>

<style scoped>
    .sub-intro{
        font-size: large;
        font-weight: 400;
    }

    .my-headline{
        font-size: xx-large;
        font-weight: 300;
        font-style: italic;
    }

    .mybg{
        background-color: var(--v-primary-base);
    }

    .my-fit{
        width: 100%;
        height: 100%;
        object-fit: cover;
        min-height: 500px;
    }
</style>